import { render, staticRenderFns } from "./backOrderManage.vue?vue&type=template&id=05b3ba7e&scoped=true"
import script from "./backOrderManage.vue?vue&type=script&lang=js"
export * from "./backOrderManage.vue?vue&type=script&lang=js"
import style0 from "./backOrderManage.vue?vue&type=style&index=0&id=05b3ba7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b3ba7e",
  null
  
)

export default component.exports